import styled from "styled-components";
import { Link } from "react-router-dom";
import logo from "../imgs/logo.png";

export default function Home() {
  return (
    <Main>
      <Container>
        <a
          href="http://www.drusajoias.com.br/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logo} alt="Drusa Joias"></img>
        </a>
        <Botoes>
          <Link to={"/instrucao-calibragem"}>
            <button>Medir com anel</button>
          </Link>

          <Link to={"/instrucao-sem-anel"}>
            <button>Medir com barbante</button>
          </Link>
          <a
            href="http://www.drusajoias.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <button>Visitar a loja online</button>
          </a>
        </Botoes>
      </Container>
      <Dev>
        <a href="https://linktr.ee/israel.felipe" target="blank">
          <h1>Desenvolvido por: Israel Felipe</h1>
        </a>
      </Dev>
    </Main>
  );
}

const Main = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const Container = styled.div`
  width: 80vw;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  background: rgba(255, 255, 255, 0.35);
  box-shadow: 0 8px 32px 0 rgba(149, 114, 39, 0.37);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);

  @media (min-width: 500px) {
    height: 70vh;
  }

  @media (min-width: 1300px) {
    flex-direction: inherit;
    height: 70vh;
  }

  img {
    width: 80vw;
    max-width: 400px;
    max-height: 40vh;
    cursor: pointer;

    @media (min-width: 1300px) {
      max-width: 40vw;
      max-height: 100%;
    }
  }
`;

const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 15px;

  @media (min-width: 1300px) {
    height: 100%;
    width: 100%;
  }

  button {
    width: 60vw;
    height: auto;
    padding: 20px;
    background-color: #cdbee7;
    color: #2a0670;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #2a0670;
    border-radius: 10px;
    cursor: pointer;

    @media (min-width: 1300px) {
      margin: 0 5%;
      width: 90%;
      height: 20vh;
      font-size: 2vw;
    }
  }
`;

const Dev = styled.h1`
  position: fixed;
  bottom: 0vh;
  width: auto;
  padding: 10px;
  height: 5vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;

  h1 {
    color: #cdbee7;
    cursor: pointer;

    @media (min-width: 1300px) {
      font-size: 20px;
    }
  }
`;
